import dayjs from 'dayjs';
import React, { ReactNode } from 'react';
import { Column } from 'services/chronogram.service';

interface ChronogramHeaderProps {
  columns: Column[];
  center: boolean;
  offset: number;
  goToDay?: ( day: dayjs.Dayjs ) => void;
  offsetChildren?: ReactNode
}

export const ChronogramHeader: React.FC<ChronogramHeaderProps> = ( {
  columns,
  center,
  offset,
  goToDay,
  offsetChildren = undefined
} ) => {

  return (
    <div className="grid w-full border overflow-hidden border-gray-200 divide-gray-200" style={{ gridTemplateColumns: `repeat(${columns.length + offset}, minmax(0, 1fr))` }} >

      <div className="h-full min-w-[180px] max-w-[180px] pr-4" style={{ gridColumn: `span ${offset}` }}>
        { offsetChildren }
      </div>

      <div style={{ gridColumn: `span ${columns.length}` }}>
        <div className="grid w-full h-full items-end" style={{ gridTemplateColumns: `repeat(${columns.length}, minmax(0, 1fr))` }}>

          {columns.map( ( col, index ) => {
            return (
              <div key={index} className='border-l'>
                <div
                  className={ `text-center  ${ goToDay && 'hover:bg-gray-200 prevent-select cursor-pointer'}` }
                  style={{ transform: center ? 'translateX(-50%)' : '' }}
                  onClick={() => { return ( goToDay && goToDay( dayjs( col.rawValue ) ) ); }}
                >
                  {( index % ( offset - 2 ) !== 0 ) ?
                    <h5 className={'text-sm text-gray-400 mt-1.5'}> {col.name} </h5> :
                    <h5 className={'text-lg font-medium text-gray-500'}> {col.name} </h5>
                  }
                </div>
                { ( col.subColumns && col.subColumns.length > 0 ) &&
                  <div className='border-t flex place-items-stretch'>
                    { col.subColumns.map( ( sub, i ) => {
                      return <p key={`${index}_${i}_${sub}`} className='border-dotted border-x text-gray-600 text-center w-full text-xs'>{ sub }</p>;
                    } ) }
                  </div>
                }
              </div>
            );
          } )}
        </div>
      </div>
    </div>
  );
};
